import React from 'react';

const SearchIcon: React.FC = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6426 10.998H11.8526L11.5726 10.728C12.5526 9.58805 13.1426 8.10805 13.1426 6.49805C13.1426 2.90805 10.2326 -0.00195312 6.64258 -0.00195312C3.05258 -0.00195312 0.142578 2.90805 0.142578 6.49805C0.142578 10.088 3.05258 12.998 6.64258 12.998C8.25258 12.998 9.73258 12.408 10.8726 11.428L11.1426 11.708V12.498L16.1426 17.488L17.6326 15.998L12.6426 10.998ZM6.64258 10.998C4.15258 10.998 2.14258 8.98805 2.14258 6.49805C2.14258 4.00805 4.15258 1.99805 6.64258 1.99805C9.13258 1.99805 11.1426 4.00805 11.1426 6.49805C11.1426 8.98805 9.13258 10.998 6.64258 10.998Z" fill="#333333"/>
    </svg>
);

export default SearchIcon;
